(ns frontend.ui.component.select-input-group.view
  (:require
   [frontend.ui.component.label.view :refer [label]]
   [frontend.ui.component.select-input-group.style
    :refer
    [select-input-group-style]]
   [frontend.ui.component.select-input.view :refer [select-input]]
   [frontend.ui.component.text.view :refer [text]]
   [herb.core :refer [<class]]))

(defn select-input-group
  [{:keys [title multi? value on-change]}
   options]
  [:div ;; TODO
   {:class (<class select-input-group-style)}
   [label
    title]
   [select-input
    {:name      title
     :multi?    multi?
     :value     value
     :on-change on-change}
    options]])
